module.exports = __webpack_public_path__ + "media/photo/electrics_bgs - Copy-45f31919.jpg";